import {
  AmadeusIcon,
  AmazonConnectIcon,
  AthenaOneIcon,
  CendynIcon,
  ConfluenceIcon,
  DialpadIcon,
  EpicIcon,
  FiveNineIcon,
  FreshdeskIcon,
  GenesysIcon,
  GladlyIcon,
  GoogleCalendarIcon,
  GoogleDriveIcon,
  GoogleSheetsIcon,
  HubspotIcon,
  JiraIcon,
  MicrosoftDynamicsIcon,
  MicrosoftIcon,
  MicrosoftOutlookIcon,
  MicrosoftTeamsIcon,
  ModmedIcon,
  NiceIcon,
  NotionIcon,
  OneDriveIcon,
  OpentableIcon,
  OracleCernerIcon,
  RaintreeIcon,
  SalesforceIcon,
  ServiceNowIcon,
  SharePointIcon,
  SlackIcon,
  SmsIcon,
  TripleseatIcon,
  TwilioIconAlt,
  WhatsappIcon,
  ZendeskIconAlt,
  ZoomIcon,
} from '../components/atoms/Icons';

export const INTEGRATION_LOGO_MAP = {
  // Telephony
  five9: FiveNineIcon,
  nice: NiceIcon,
  twilio: TwilioIconAlt,
  'amazon-connect': AmazonConnectIcon,
  genesys: GenesysIcon,
  'zendesk-talk': ZendeskIconAlt,
  zoom: ZoomIcon,
  dialpad: DialpadIcon,
  // Project Management
  jira: JiraIcon,
  // Calendar
  googleCalendar: GoogleCalendarIcon,
  // Chat
  whatsapp: WhatsappIcon,
  sms: SmsIcon,
  'salesforce-chat': SalesforceIcon,
  // CRM
  'salesforce-crm': SalesforceIcon,
  'zendesk-crm': ZendeskIconAlt,
  'microsoft-dynamics-365': MicrosoftDynamicsIcon,
  hubspot: HubspotIcon,
  // Hospitality - Restaurant
  opentable: OpentableIcon,
  cendyn: CendynIcon,
  hotsos: AmadeusIcon,
  // Healthcare
  modmed: ModmedIcon,
  epic: EpicIcon,
  athenaone: AthenaOneIcon,
  'cerner-oracle-health': OracleCernerIcon,
  raintree: RaintreeIcon,
  // Knowledge Base
  'zendesk-knowledge-management': ZendeskIconAlt,
  'salesforce-knowledge-management': SalesforceIcon,
  gladly: GladlyIcon,
  'azure-ai-search': MicrosoftIcon,
  servicenow: ServiceNowIcon,
  slack: SlackIcon,
  notion: NotionIcon,
  googleDrive: GoogleDriveIcon,
  googleSheets: GoogleSheetsIcon,
  microsoftTeams: MicrosoftTeamsIcon,
  microsoftOutlook: MicrosoftOutlookIcon,
  oneDrive: OneDriveIcon,
  sharepoint: SharePointIcon,
  confluence: ConfluenceIcon,
  freshdesk: FreshdeskIcon,
  'custom.tripleseat': TripleseatIcon,
} as const;
